import { DictionaryModule, ServiceResponseModule } from '@sdbn/appclient';
import { RegisterEntranceCombinedComponent } from './component/register-entrance-combined/register-entrance-combined.component';
import { RegisterLeaveCombinedComponent } from './component/register-leave-combined/register-leave-combined.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { MaterialModule } from '@sdbn/appclient';
import { DeleteTransportDialogComponent } from './component/delete-transport-dialog/delete-transport-dialog.component';
import { EndTransportPauseDialogComponent } from './component/end-transport-pause-dialog/end-transport-pause-dialog.component';
import { GcCaseDialogComponent } from './component/gc-case-dialog/gc-case-dialog.component';
import { StartTransportPauseDialogComponent } from './component/start-transport-pause-dialog/start-transport-pause-dialog.component';
import { TruckGcCaseDialogComponent } from './component/truck-gc-case-dialog/truck-gc-case-dialog.component';
import { TruckInfoPanelModule } from 'src/tmc-yard/common/truck-info-panel/truck-info-panel.module';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/appclient';

@NgModule({
  declarations: [
    GcCaseDialogComponent,
    DeleteTransportDialogComponent,
    StartTransportPauseDialogComponent,
    EndTransportPauseDialogComponent,
    RegisterLeaveCombinedComponent,
    RegisterEntranceCombinedComponent,
    TruckGcCaseDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    QRCodeModule,
    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TruckInfoPanelModule,
    DictionaryModule,
    CommonTranslationModule,
    ServiceResponseModule,
    ApplicationClientCommonModule
  ],
  exports: [
    GcCaseDialogComponent,
    DeleteTransportDialogComponent,
    StartTransportPauseDialogComponent,
    EndTransportPauseDialogComponent,
    RegisterLeaveCombinedComponent,
    RegisterEntranceCombinedComponent,
    TruckGcCaseDialogComponent
  ]
})
export class VisitOverviewModule { }
